.container {
  max-width: 100%;
}

.panel {
  //width: unset !important;
  //height: unset !important;
}
